import React, { useEffect } from 'react'
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Login from './screens/login'
import Forgot from './screens/forgotpassword';
import ResetPassword from './screens/resetpassword/web/ResetPassword';
// import Sidebar from './Sidebar';
import Onboard from './screens/onboard/index';
import OnboardEmployee from './screens/onboarded/index';
import Notification from './screens/notifications/';

import ViewLead from './screens/lead/';
import ViewDeal from './screens/deal/';
import ViewContact from './screens/contacts/';
import ViewTasks from './screens/tasks/';
import ViewMettings from './screens/mettings/';
import Analytics from './screens/Analytics/Analytics';

import BdDashboard from './screens/dashboard/bd_dashboard';
import ControllerDashboard from './screens/dashboard/controller_dashboard';


import CreateLead from './screens/lead/index1'
import CreateDeal from './screens/deal/index1'
import CreateContact from './screens/contacts/index1'
import CreateTasks from './screens/tasks/index1'

import LeadDetail from './screens/lead/index2';
import DealDetail from './screens/deal/index2';
import ContactDetail from './screens/contacts/index2';
import TaskDetail from './screens/tasks/index2';
import MettingDetail from './screens/mettings/index1';

import TrackLead from './screens/lead/web/TrackLead';


import { useLocation } from "react-router";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";



import Navbar from './screens/navbar/';
import Profile from './screens/profile/';
import MoreOption from './screens/more/MoreOption';

import axios from 'axios';
import EditProfile from './screens/profile/index1';

import Add_DDR from './screens/AddingControllerComponents/index'

import HomeMain from './screens/home/HomeMain';

import TeamCLD from './screens/bdsuperadmin/index';



//protectedRoutes
import RequireAuth from './protectedRoutes/RequireAuth'
import PageNotFound from './screens/pagenotfound/web/PageNotFound';
import PageNotFound1 from './screens/pagenotfound/web/PageNotFound1';
import LinkExpire from './screens/pagenotfound/web/LinkExpire'
// import KrishnaDashboard from './screens/dashboard/KrishnaDashboard';
import UpdatePassword from './screens/updatepassword/web/UpdatePassword';


import CLDmainDesign from './components/detail_design/CLDmainDesign'
import AddIndustry from './screens/KrishnaDashboardPages/index1';
import AddContactSource from './screens/KrishnaDashboardPages/index2';
import DeveloperDashboard from './screens/KrishnaDashboardPages/DeveloperDashboard';

import { message, notification } from 'antd'
import Notesui from './components/bdcomponenttable/mobileComponents/Notesui';
import Attachmentsui from './components/bdcomponenttable/mobileComponents/Attachmentsui';

// import { messaging } from './firebase'
// import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { useDispatch } from 'react-redux';
import { device_token } from './redux/actionPayload/AuthPayload';
import Reportgeneration from './screens/KrishnaDashboardPages/web/Reportgeneration';
import Settings from './screens/KrishnaDashboardPages/web/Settings';

// import firebase from './firebase';
// import MailNavbar from './screens/mail/web/MailNavbar';

//server url 
axios.defaults.baseURL = 'http://ec2-13-233-103-60.ap-south-1.compute.amazonaws.com:5000/api/'

// test url 
// axios.defaults.baseURL = 'http://ec2-3-110-50-241.ap-south-1.compute.amazonaws.com:5000/api/'

//local url 
// axios.defaults.baseURL = 'http://localhost:4000/api/'

//server url update test 1
export const base_url = 'http://ec2-13-233-103-60.ap-south-1.compute.amazonaws.com:5000/'

// test url 
// export const base_url = 'ec2-3-110-50-241.ap-south-1.compute.amazonaws.com:5000/'

//local url 
// export const base_url = 'http://localhost:4000/'

message.config({
  maxCount: 1,
})

const Root = () => {
  const location = useLocation()


  const { pathname } = location



  return (
    // <>

    // </>
    <div>

      {window.innerWidth > 768 && location.pathname !== '/login' && location.pathname !== '/forgot_password' && location.pathname !== '/update-password' && location.pathname !== '/reset-password' && location.pathname !== '/' && location.pathname !== '/notifications' && location.pathname !== '/profile' && location.pathname !== '/more-options' && location.pathname !== '/krishna_dashboard' && location.pathname !== '/add_industry' && location.pathname !== '/contact_source' && location.pathname !== '/crm_report'  && location.pathname !== '/settings' && <Navbar />}
      {window.innerWidth < 768 &&
        location.pathname !== '/login' &&
        location.pathname !== '/forgot_password' &&
        location.pathname !== '/reset-password?token=:token' &&
        location.pathname !== '/update-password' &&
        location.pathname !== '/' &&
        location.pathname !== '/notifications' &&
        location.pathname !== '/profile' &&
        location.pathname !== '/more-options' &&
        location.pathname !== '/create_contact' &&
        location.pathname !== '/create_deal' &&
        location.pathname !== '/create_lead' &&
        location.pathname !== '/create_tasks' &&
        location.pathname !== '/lead_detail' &&
        location.pathname !== '/deal_detail' &&
        pathname.split('/')[1] !== 'contact_detail' &&
        pathname.split('/')[1] !== 'lead_detail' &&
        pathname.split('/')[1] !== 'deal_detail' &&
        pathname.split('/')[1] !== 'edit_task' &&
        pathname.split('/')[1] !== 'edit_contact' &&
        pathname.split('/')[1] !== 'edit_lead' &&
        pathname.split('/')[1] !== 'edit_deal' &&
        pathname.split('/')[1] !== 'notes_ui' &&
        pathname.split('/')[1] !== 'attachments_ui' &&
        pathname !== '/on_board' &&
        pathname !== '/onboarded_employee' &&
        pathname !== '/TeamCLD' &&
        pathname.split('/')[1] !== 'on_board_user_update' &&
        location.pathname !== '/view_meetings' &&
        location.pathname !== '/view_tasks' &&
        location.pathname !== '/view_contacts' &&
        location.pathname !== '/view_deals' &&
        location.pathname !== '/view_leads' &&
        location.pathname !== '/krishna_dashboard' &&
        location.pathname !== '/add_industry' &&
        location.pathname !== '/contact_source' &&
        location.pathname !== '/crm_report' && <Navbar />}

      <Routes>
        <Route path="/" element={<HomeMain />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot_password" exact element={<Forgot />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/main_ra" exact element={<CLDmainDesign />} />


        <Route element={<RequireAuth allowedRoles={['admin', 'hod', 'manager', 'db_head', 'db_user', 'db_sub_user', 'bd_user', 'controller']} />}>
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/notifications" exact element={<Notification />} />
          <Route path="/profile" exact element={<Profile />} />
          <Route path="/edit-profile" exact element={<EditProfile />} />
        </Route>


        <Route element={<RequireAuth allowedRoles={['admin', 'hod', 'manager', 'db_head', 'db_user', 'db_sub_user', 'bd_user']} />}>
          <Route path="/bd_dashboard" exact element={<BdDashboard />} />

          <Route path="/view_leads" exact element={<ViewLead />} />
          <Route path="/view_deals" exact element={<ViewDeal />} />
          <Route path="/view_contacts" exact element={<ViewContact />} />
          <Route path="/view_tasks" exact element={<ViewTasks />} />
          <Route path="/view_meetings" exact element={<ViewMettings />} />
          <Route path="/view_analytics" exact element={<Analytics />} />

          <Route path="/create_lead" exact element={<CreateLead />} />
          <Route path="/create_deal" exact element={<CreateDeal />} />
          <Route path="/create_contact" exact element={<CreateContact />} />
          <Route path="/create_tasks" exact element={<CreateTasks />} />

          <Route path="/lead_detail/:id" exact element={<LeadDetail />} />
          <Route path="/deal_detail/:id" exact element={<DealDetail />} />
          <Route path="/contact_detail/:id" exact element={<ContactDetail />} />
          <Route path="/task_detail" exact element={<TaskDetail />} />
          <Route path="/meeting_detail" exact element={<MettingDetail />} />

          <Route path="/notes_ui/:type/:id" exact element={<Notesui />} />
          <Route path="/attachments_ui/:type/:id" exact element={<Attachmentsui />} />

          <Route path="/edit_task/:id" exact element={<CreateTasks />} />
          <Route path="/edit_lead/:lead_id" exact element={<CreateLead />} />
          <Route path="/edit_contact/:contact_id" exact element={<CreateContact />} />
          <Route path="/edit_deal/:deal_id" exact element={<CreateDeal />} />

          <Route path="/track_lead" exact element={<TrackLead />} />
          <Route path="/TeamCLD" exact element={<TeamCLD />} />


          <Route path="/more-options" exact element={<MoreOption />} />
        </Route>

        <Route element={<RequireAuth allowedRoles={['admin', 'controller']} />}>
          <Route path="/controller_dashboard" exact element={<ControllerDashboard />} />
          <Route path="/on_board" exact element={<Onboard />} />
          <Route path="/on_board_user_update/:id" exact element={<Onboard />} />
          <Route path="/departments" exact element={<Add_DDR />} />
          <Route path="/designation" exact element={<Add_DDR />} />
          <Route path="/roles" exact element={<Add_DDR />} />
          <Route path="/Add_DDR" exact element={<Add_DDR />} />
          <Route path="/onboarded_employee" exact element={<OnboardEmployee />} />

        </Route>

        <Route path="/permission_not_provided" exact element={<PageNotFound />} />
        <Route path="*" exact element={<PageNotFound1 />} />
        <Route path="/link_expired" exact element={<LinkExpire />} />


        <Route path="/krishna_dashboard" exact element={<DeveloperDashboard />} />
        <Route path="/add_industry" exact element={<AddIndustry />} />
        <Route path="/contact_source" exact element={<AddContactSource />} />
        <Route path="/crm_report" exact element={<Reportgeneration />} />
        <Route path="/settings" exact element={<Settings />} />

      </Routes>



    </div>
  )

}

function App() {

  const dispatch = useDispatch()


  // useEffect(() => {

  //   const messaging = firebase.messaging();
  //   messaging.usePublicVapidKey("BFB4P-S9nzXYW52rsqY3i1Z4Zw4J4Fc-iY7eNYhtEVn7J1h7RFaTuIO7AfUzA2okWiHxpPYyXQWOaeAM7YewFHg")
  //   messaging
  //     .requestPermission()
  //     .then(() => {
  //       return messaging.getToken();
  //     })
  //     .then((token) => {
  //       dispatch(device_token(token))
  //       // console.log('token is ...', token)
  //     }).catch((err) => {
  //       // console.log('err here', err)
  //     })
  // }, [])

  return (
    <Router>
      <Root />
    </Router>
  );
}

export default App;